import apiClient from '../plugins/api_client.js'
import store from "../store/index.js"

export const baseUrl = process.env.VUE_APP_URL_API+"/types";

export default class TypesService {

    getTypes(is_active = 1) {
      return new Promise( (resolve, reject) => {
          apiClient.get(`${baseUrl}?is_active=${is_active}`,
          {headers: {'Authorization': 'Bearer ' + store.state.token}})
          .then(function(response){
            resolve(response.data);
          })
          .catch(function(error){
            reject(error);
          });
      })
    }

}